import * as actionTypes from "./actionTypes";

const initialState = {
  loading: false,
  filters: { keyword: "" },
  PermissionsList: {},
  roles: [],
  errors: { projectId: "", sourceType: "", files: "" },
  errorMessage: "",
};

const Permissions = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case actionTypes.SET_ERRORS:
      return {
        ...state,
        errors: action.payload,
      };
    case actionTypes.SET_FILTERS:
      return {
        ...state,
        filters: action.payload,
      };
    case actionTypes.GET_PERMISSIONS_SUCCESS:
      return {
          ...state,
          loading: false,
          PermissionsList: action.payload,
          // errors: { projectId: "", sourceType: "", files: "" },
          // errorMessage: "",
      };
    case actionTypes.GET_PERMISSIONS_FAILURE:
      return {
          ...state,
          loading: false,
          errors: action.payload.data,
          errorMessage: action.payload.message
      };
    case actionTypes.CREATE_PERMISSION_SUCCESS:
      return {
          ...state,
          loading: false,
          // PermissionsList: action.payload,
          // errors: { projectId: "", sourceType: "", files: "" },
          // errorMessage: "",
      };
    case actionTypes.CREATE_PERMISSION_FAILURE:
      return {
          ...state,
          loading: false,
          errors: action.payload.data,
          errorMessage: action.payload.message
      };
    case actionTypes.UPDATE_PERMISSION_SUCCESS:
        return {
            ...state,
            loading: false,
            // PermissionsList: action.payload,
            // errors: { projectId: "", sourceType: "", files: "" },
            // errorMessage: "",
        };
    case actionTypes.UPDATE_PERMISSION_FAILURE:
        return {
            ...state,
            loading: false,
            errors: action.payload.data,
            errorMessage: action.payload.message
        };
    case actionTypes.DELETE_PERMISSION_SUCCESS:
      return {
          ...state,
          loading: false,
          errorMessage: "",
      };
    case actionTypes.DELETE_PERMISSION_FAILURE:
      return {
          ...state,
          loading: false,
          errors: action.payload.data,
          errorMessage: action.payload.message
      };
    default:
        return state;
  }
};

export default Permissions;
